<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>

<script>
import WatermarkUtil from "@/utils/watermark.js";
import Cookies from "js-cookie";
export default {
  name: 'App',
  mounted() {
    this.initWatermark();
  },
  beforeDestroy() {
    WatermarkUtil.destroyWatermark();
  },
  methods: {
    async initWatermark() {
      const token = Cookies.get("Dealer-User-Token");
      if (token) {
        await WatermarkUtil.initWatermark();
      }
    }
  }
}
</script>
